// Trypay.jsx (React)
import React, { useState } from 'react';

export default function Trypay() {
    const [amount, setAmount] = useState('91.96');
    const [loading, setLoading] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        setLoading(true);
        try {
            const resp = await fetch('https://appapi.albionline.com/api/paynow/initiate', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amount })
            });
            const data = await resp.json();
            if (!resp.ok) throw new Error(data.error || 'Create payment failed');

            // Build and submit a form with hidden inputs
            const form = document.createElement('form');
            form.method = 'post';
            form.action = data.gatewayUrl;
            // Add each param as hidden input
            for (const [k, v] of Object.entries(data.params)) {
                const input = document.createElement('input');
                input.type = 'text';
                input.name = k;
                input.value = v ?? '';
                form.appendChild(input);
            }
            document.body.appendChild(form);
            form.submit(); // user goes to the bank payment page (hosted by NestPay)
        } catch (err) {
            alert('Error creating payment: ' + err.message);
            setLoading(false);
        }
    }

    return (
        <form onSubmit={handleSubmit}>
            <div>
                <label>Amount</label>
                <input value={amount} onChange={e => setAmount(e.target.value)} />
            </div>
            <button type="submit" disabled={loading}>{loading ? 'Redirecting...' : 'Pay now'}</button>
        </form>
    );
}

